import React from 'react';
import {
  Box,
  Button,
  Text,
  Flex,
  Link,
  useColorModeValue,
  CloseButton,
} from '@chakra-ui/react';
import { useConsent } from '../contexts/ConsentContext';

const CookieConsentBanner = () => {
  const { showConsentBanner, setCookieConsent, dismissConsentBanner } = useConsent();
  const bgColor = useColorModeValue('rgba(255, 255, 255, 0.9)', 'rgba(10, 10, 10, 0.9)');
  const textColor = useColorModeValue('gray.700', 'gray.200');

  if (!showConsentBanner) {
    return null;
  }

  return (
    <Box
      position="fixed"
      bottom="0"
      left="0"
      right="0"
      zIndex={9999}
      p={4}
      bg={bgColor}
      backdropFilter="blur(10px)"
      borderTop="1px solid"
      borderColor="whiteAlpha.300"
      boxShadow="0 -4px 10px rgba(0, 0, 0, 0.1)"
    >
      <Flex 
        maxW="1200px" 
        mx="auto" 
        direction={{ base: 'column', md: 'row' }} 
        justify="space-between"
        align={{ base: 'flex-start', md: 'center' }}
      >
        <Box flex="1" pr={{ base: 0, md: 4 }}>
          <Text color={textColor} mb={{ base: 3, md: 0 }}>
            We use cookies to enhance your experience. By continuing to visit this site you agree to our use of cookies. 
            Learn more in our{' '}
            <Link href="/privacy" color="blue.500" isExternal>
              Privacy Policy
            </Link>.
          </Text>
        </Box>
        <Flex gap={2} alignSelf={{ base: 'flex-end', md: 'center' }}>
          <Button
            colorScheme="gray"
            size="sm"
            onClick={dismissConsentBanner}
            variant="outline"
          >
            Decline
          </Button>
          <Button
            colorScheme="green"
            size="sm"
            onClick={() => setCookieConsent(true)}
          >
            Accept
          </Button>
          <CloseButton 
            onClick={dismissConsentBanner} 
            size="sm" 
            ml={1} 
            color={textColor}
          />
        </Flex>
      </Flex>
    </Box>
  );
};

export default CookieConsentBanner; 